import * as React from "react";
import { Component } from "react";
import { Observation } from "../../api/StudyApi";
import Moment from "react-moment";
import i18n from "i18next";

interface ObsHistoryProps {
  obs: Observation;

  onAddValidatedBy(): void;
}

export default class ObsHistory extends Component<ObsHistoryProps> {
  constructor(props: ObsHistoryProps, context: any) {
    super(props, context);
  }

  render() {
    return (
      <>
        <div className="py-2">
          {this.props.obs.validatedBy.length == 0 && <div>Aucune validation</div>}

          {this.props.obs.validatedBy.length > 0 && (
            <div>
              Validations : [
              {this.props.obs.validatedBy.map((vb, idx) => (
                <span key={idx}>
                  {vb}
                  {idx != this.props.obs.validatedBy.length - 1 && <>, </>}
                </span>
              ))}
              ]
              <button
                title="Ajouter ma validation"
                className="ml-2 btn btn-secondary"
                onClick={(evt) => this.props.onAddValidatedBy()}
              >
                <span className="badge-container" data-count={this.props.obs.validatedBy.length}>
                  <i className="fa fa-check" />
                </span>
              </button>
            </div>
          )}
        </div>

        <table className="table table-striped table-responsive">
          <tbody>
            <tr>
              <th>{i18n.t("study.date")}</th>
              <th>{i18n.t("admin.author")}</th>
              <th>{i18n.t("obs.level")}</th>
              <th>{i18n.t("obs.role")}</th>
              <th>{i18n.t("task.state")}</th>
              <th>{i18n.t("obs.excludedReason")}</th>
              <th>{i18n.t("admin.duration")} (s)</th>
              <th>{i18n.t("obs.cardinality")}</th>
              <th>WorkflowId</th>
            </tr>
            {this.props.obs.history.map((item, idx) => (
              <tr key={idx}>
                <td>
                  <Moment format="DD/MM/YYYY HH:mm:ss">{item.tsp}</Moment>
                </td>
                <td>{item.author}</td>
                <td>{item.level}</td>
                <td>{item.role}</td>
                <td>{item.state}</td>
                <td>{item.excludedReason}</td>
                <td>{item.secDuration}</td>
                <td>{item.cardinality}</td>
                <td>{item.workflowId}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </>
    );
  }
}
